import { PageContainer } from '@ant-design/pro-components'
import { createFileRoute, redirect } from '@tanstack/react-router'
import { ServiceOrderDetails } from '@/features/order/index.ts'

export const Route = createFileRoute('/_authenticated/orders/service/$orderId/')({
  beforeLoad: ({ params }) => {
    if (!Number.isSafeInteger(Number(params.orderId)) || Number(params.orderId) < 1) {
      throw redirect({ to: '/orders/service', search: { current: 1, pageSize: 20 }, replace: true })
    }
  },
  head: () => ({ meta: [{ title: '服务订单详情 · Super Mega' }] }),
  component: ServiceOrderDetailPage
})

function ServiceOrderDetailPage() {
  return (
    <PageContainer title="服务订单详情" breadcrumbRender={false}>
      <ServiceOrderDetails id={Number(Route.useParams().orderId)} />
    </PageContainer>
  )
}
